Ext.ns('mx.data');

mx.data.GeoPoint = mx.data.Record.create(
    [
        {name: 'id', type: 'string'},
        {name: 'name', type: 'string'},
        {name: 'time', type: 'string'},
        {name: 'date', type: 'date', dateFormat: 'time'},
        {name: 'longitude', type: 'string'},
        {name: 'latitude', type: 'string'},
        {name: 'speed', type: 'int'},
        {name: 'odometer', type: 'int'},
        {name: 'altitude', type: 'int'},
        {name: 'heading', type: 'int'},
        {name: 'type', type: 'string'},
        {name: 'postcode', type: 'string'},
        {name: 'divisionId', type: 'int'},
        {name: 'aocId', type: 'int'},
        {name: 'description', type: 'string'},
        {name: 'locationName', type: 'string'},
        {name: 'alertType', type: 'string'},
        {name: 'alertText', type: 'string'},
        {name: 'hasDeliverySchedule', type: 'boolean'},
        {name: 'shipmentTypes', type: 'mx.data.SimpleRecord[]'},
        {name: 'code', type: 'string'},
    ],
    MXAT.API('geocodings/')
);

mx.data.GeoPoint.prototype.toString = function() {
    return Ext.encode(this);
};

new mx.data.Store({
    storeId: 'geocoding',
    url: MXAT.API('geocodings/'),
    record: mx.data.GeoPoint,
});

mx.data.GeoPoint.geoToMxnPoint = function(point) {
    var result = {};
    if (point.get) {
        result.lat = point.get('latitude');
        result.lon = point.get('longitude');
    }
    return result;
};
